import { MutableRefObject, useRef } from "react";
import PassApi from "../../data/PassApi";
import { useOverlay } from "../../gui/Overlay/OverlayProvider";
import { useSnackbar } from "../../gui/Snackbar/SnackbarProvider";
import TextInput, { ITextInput } from "../../gui/TextInput/TextInput";
import FormControl from "../../gui/Form/FormControl";
import { UpdateEvent } from "../../gui/GUIEvents";
import Validators from "../../gui/Form/Validators";
import Button from "../../gui/Button/Button";

export default function ChangePassword(){
    const oldPassword = useRef<ITextInput|null>(null)
    const newPassword = useRef<ITextInput|null>(null)
    const refConfirm = useRef<ITextInput|null>(null)
    const {popOverlay} = useOverlay()
    const {addSnackbar} = useSnackbar()
    
    const onPassword = (ref:MutableRefObject<ITextInput|null>) => (e:UpdateEvent<string>) => ref.current?.validate(ref.current?.value, false)
    const PasswordMatch = (ref:MutableRefObject<ITextInput|null>) => (val:string) => {
        if (!ref.current) return "Password is required"
        else if (val!=ref.current.value) return "Password must match"
        else return null
    }
    const onCreate = async () => {
        try {
            await PassApi.i.updatePassword(oldPassword.current!.value!, newPassword.current!.value!)
            onClose()
        }catch(e){
            addSnackbar(e)
        }
    }
    const onClose = () => popOverlay("passwordDlg")
    return <>
        <h2>Change Password</h2>
        <div className="content">
            <FormControl validators={[Validators.Required("Current")]}>
                <TextInput placeholder="Current Password" ref={oldPassword} inputProps={{type:"password"}} float={true}/>
            </FormControl>
            <FormControl validators={[Validators.Required("Password"), PasswordMatch(refConfirm)]}>
                <TextInput placeholder="New Password" ref={newPassword} inputProps={{type:"password"}} float={true} onUpdate={onPassword(refConfirm)}/>
            </FormControl>
            <FormControl validators={[Validators.Required("Password"), PasswordMatch(newPassword)]}>
                <TextInput placeholder="Confirm" ref={refConfirm} inputProps={{type:"password"}} float={true} onUpdate={onPassword(newPassword)}/>
            </FormControl>
        </div>
        <div className="actions">
            <Button onClick={onClose}>Cancel</Button>
            <Button variant="contained" onClick={onCreate}>Update</Button>
        </div>
    </>
}